/*
 * VALTIVA — Configuration bundles v2 (CANARY PROTOTYPE)
 *
 * What this does (theme-level only; it is NOT server-side validation and does not
 * protect checkout paths that bypass the theme):
 *  1. Product page (only the four allow-listed canary products): every Add click is one
 *     "configuration". All its lines (main item + colour/add-on lines) get the same unique
 *     hidden _bundle_id, an explicit _bundle_role and _bundle_v=2, so Shopify never merges
 *     two configurations. Repeat adds show each existing configuration individually; the
 *     customer explicitly chooses "Replace this configuration", "Add as a separate item"
 *     or "Cancel". Replacement is add-first / remove-second with every response checked.
 *  2. Cart page + drawer: bundled lines have locked quantity (markup from cart-item.liquid),
 *     required add-on lines cannot be removed on their own, removing a main line removes the
 *     whole bundle, and a guard flags and explains inconsistent carts (orphan, incomplete,
 *     quantity mismatch, pending replacement, unverifiable legacy lines) and disables the
 *     Checkout button in the page UI until they are resolved by an explicit customer action.
 * Loaded on every page; inert unless a cart line carries bundle properties or a canary
 * product page is shown. Beds, mattresses and all other products are not touched.
 */
(function () {
  'use strict';
  if (window.valtivaBundles) return;

  var CFG = window.VALTIVA_BUNDLES || {};
  var CANARY = CFG.handles || [];
  var K = { ID: '_bundle_id', ROLE: '_bundle_role', VER: '_bundle_v', REPL: '_bundle_replaces', N: '_bundle_n' };
  var busy = false;
  var api = {};

  /* ---------- small helpers ---------- */
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function props(i) { return (i && i.properties) || {}; }
  function isV2(i) { var p = props(i); return !!p[K.ID] && String(p[K.VER]) === '2'; }
  function roleOf(i) { return props(i)[K.ROLE] === 'addon' ? 'addon' : 'main'; }
  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }
  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function fail(code, detail) { var e = new Error(code); e.code = code; e.detail = detail; return e; }
  function copy(o) { var c = {}; for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) c[k] = o[k]; } return c; }
  function newId() {
    var r = '';
    try { var a = new Uint32Array(2); window.crypto.getRandomValues(a); r = a[0].toString(36) + a[1].toString(36); } catch (e) { r = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2); }
    return 'b' + Date.now().toString(36) + '-' + r.slice(0, 8);
  }
  function labelOf(i) { return i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : (i.product_title || ''); }

  /* ---------- cart API (never assumed atomic; every response is checked) ---------- */
  function http(method, url, body) {
    var opts = { method: method, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; }, function () { return { ok: r.ok, status: r.status, data: null }; });
    }, function () { return { ok: false, status: 0, data: null }; });
  }
  function readCart() {
    return http('GET', '/cart.js').then(function (r) {
      if (!r.ok || !r.data || !r.data.items) throw fail('cart-read');
      return r.data;
    });
  }
  function removeKeys(keys) {
    if (!keys.length) return Promise.resolve();
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    return http('POST', '/cart/update.js', { updates: updates }).then(function (r) {
      if (!r.ok || !r.data || !r.data.items) throw fail('update-failed');
      var still = r.data.items.filter(function (i) { return keys.indexOf(i.key) > -1; });
      if (still.length) throw fail('update-incomplete');
    });
  }
  function removeBundle(id) {
    function once() {
      return readCart().then(function (c) {
        var keys = c.items.filter(function (i) { return props(i)[K.ID] === id; }).map(function (i) { return i.key; });
        return removeKeys(keys);
      });
    }
    return once().catch(function () { return delay(350).then(once); });
  }

  /* ---------- configurations ---------- */
  function describe(cart, main) {
    var p = props(main), id = p[K.ID], v2 = isV2(main);
    var addons = v2 ? cart.items.filter(function (i) { return props(i)[K.ID] === id && roleOf(i) === 'addon'; }) : [];
    return { id: id, legacy: !v2, key: main.key, qty: main.quantity, size: main.variant_title && main.variant_title !== 'Default Title' ? main.variant_title : '', fabric: p.Fabric || '', addons: addons.map(labelOf) };
  }
  function findConfigs(cart, variantId) {
    return cart.items.filter(function (i) { return String(i.variant_id) === String(variantId) && roleOf(i) === 'main'; }).map(function (m) { return describe(cart, m); });
  }

  /* ---------- styles (injected once) ---------- */
  function injectCss() {
    if (qs('#ValtivaBundlesCss')) return;
    var s = document.createElement('style'); s.id = 'ValtivaBundlesCss';
    s.textContent =
      '.cart__item[data-bundle-role="addon"] .js-qty__wrapper,.cart__item[data-bundle-role="addon"] .cart__remove a,.cart__item[data-bundle-id] .js-qty__adjust{display:none!important}' +
      '.valtiva-bundle-qty{font-size:13px;color:#5c5c5c;margin-bottom:6px}.valtiva-bundle-included{font-size:12px;color:#8e8e8e}' +
      '.valtiva-bundle-banner,.valtiva-bundle-notice{border:1px solid #e0b25a;background:#fff7e6;color:#1a1a1a;padding:12px 14px;border-radius:8px;font-size:13px;line-height:1.5;margin:0 0 14px}' +
      '.valtiva-bundle-banner ul{margin:6px 0 0 18px;padding:0}.valtiva-bundle-banner button,.valtiva-bundle-notice button{margin:8px 8px 0 0;padding:7px 12px;border:1px solid #0f0f0f;background:#fff;color:#0f0f0f;border-radius:6px;cursor:pointer;font-size:12.5px}' +
      '.valtiva-bundle-blocked{opacity:.45;cursor:not-allowed!important}' +
      '#ValtivaBundleModal{position:fixed;inset:0;z-index:10000;display:none;align-items:center;justify-content:center}#ValtivaBundleModal.is-open{display:flex}' +
      '#ValtivaBundleModal .vb-overlay{position:absolute;inset:0;background:rgba(15,15,15,.45)}#ValtivaBundleModal .vb-box{position:relative;background:#fff;border-radius:14px;padding:26px 24px;width:460px;max-width:92vw;max-height:88vh;overflow:auto;box-shadow:0 20px 60px rgba(15,15,15,.25)}' +
      '#ValtivaBundleModal h2{font-family:Georgia,serif;font-size:19px;margin:0 0 6px}#ValtivaBundleModal p{font-size:13.5px;color:#5c5c5c;margin:0 0 14px}' +
      '#ValtivaBundleModal .vb-card{border:1px solid #ece7de;border-radius:10px;padding:12px;margin-bottom:10px;font-size:13px}#ValtivaBundleModal .vb-card strong{color:#0f0f0f}#ValtivaBundleModal .vb-tag{display:inline-block;background:#f5f2ee;border-radius:4px;padding:1px 6px;font-size:11px;margin-left:6px}' +
      '#ValtivaBundleModal button{font-size:13px;border-radius:6px;padding:8px 12px;cursor:pointer;border:1px solid #0f0f0f;background:#fff;color:#0f0f0f;margin:8px 8px 0 0}#ValtivaBundleModal button[disabled]{opacity:.45;cursor:not-allowed}' +
      '#ValtivaBundleModal .vb-secondary{display:flex;flex-wrap:wrap;margin-top:6px}@media(max-width:480px){#ValtivaBundleModal .vb-box{padding:20px 16px}}';
    document.head.appendChild(s);
  }

  /* ---------- explicit targeting pop-up ---------- */
  function chooseConfiguration(configs, ctx) {
    injectCss();
    return new Promise(function (resolve) {
      var old = qs('#ValtivaBundleModal'); if (old) old.remove();
      var m = document.createElement('div'); m.id = 'ValtivaBundleModal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-labelledby', 'vbTitle');
      var cards = configs.map(function (c, n) {
        var same = !c.legacy && ctx.labels && c.fabric === (ctx.selections.properties.Fabric || '') && c.addons.slice().sort().join('|') === ctx.labels.slice().sort().join('|');
        return '<div class="vb-card" data-vb-card="' + n + '"><div><strong>' + esc(c.size || 'This item') + '</strong>' + (c.legacy ? '<span class="vb-tag">Added earlier</span>' : '') + (same ? '<span class="vb-tag">Same as your new selection</span>' : '') + '</div>' +
          (c.fabric ? '<div>Fabric: ' + esc(c.fabric) + '</div>' : '') + (c.addons.length ? '<div>Options: ' + esc(c.addons.join(', ')) + '</div>' : '') + '<div>Quantity in cart: ' + esc(c.qty) + '</div>' +
          (c.legacy ? '<div style="margin-top:6px">This line was added before an update, so its options cannot be matched automatically. Please remove it from your cart first if you want to change it.</div><button type="button" disabled>Replace this configuration</button> <a href="/cart" style="font-size:12.5px">View cart</a>'
                    : '<button type="button" data-vb-replace="' + esc(c.id) + '">Replace this configuration</button>') + '</div>';
      }).join('');
      m.innerHTML = '<div class="vb-overlay" data-vb-cancel></div><div class="vb-box"><h2 id="vbTitle">This item is already in your cart</h2><p>' +
        (configs.length > 1 ? 'You have ' + configs.length + ' configurations of this item. Choose which one to replace, or add this as a separate item.' : 'Choose what to do with the configuration below, or add this as a separate item.') + '</p>' + cards +
        '<div class="vb-secondary"><button type="button" data-vb-new>Add as a separate item</button><button type="button" data-vb-cancel>Cancel</button></div></div>';
      document.body.appendChild(m);
      function done(res) { document.removeEventListener('keydown', onKey, true); m.classList.remove('is-open'); m.remove(); resolve(res); }
      function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); done({ action: 'cancel' }); } }
      m.addEventListener('click', function (e) {
        var t = e.target; if (!t || !t.closest) return;
        var rep = t.closest('[data-vb-replace]'); if (rep) return done({ action: 'replace', id: rep.getAttribute('data-vb-replace') });
        if (t.closest('[data-vb-new]')) return done({ action: 'new' });
        if (t.closest('[data-vb-cancel]')) return done({ action: 'cancel' });
      });
      document.addEventListener('keydown', onKey, true);
      m.classList.add('is-open');
      var cancel = qs('.vb-secondary [data-vb-cancel]', m); if (cancel && cancel.focus) cancel.focus();   // non-destructive default focus
    });
  }

  /* ---------- product page: reading and validating the selection (mirrors the legacy rules) ---------- */
  function readSelections() {
    var out = { addonVariantIds: [], properties: {}, labels: [], missing: [] };
    qsa('[data-addon-group]').forEach(function (g) {
      if (g.closest('[hidden]')) return;
      var type = g.getAttribute('data-addon-type'), req = g.getAttribute('data-addon-required') === 'true';
      var sel = g.querySelector('[data-addon-option].is-selected');
      if (type === 'priced') {
        if (!sel) { if (req) out.missing.push(g); return; }
        var vid = sel.getAttribute('data-variant-id');
        if (vid) { out.addonVariantIds.push(vid); out.labels.push(sel.getAttribute('data-choice-label') || ''); }
      } else if (type === 'property') {
        var first = g.querySelector('[data-addon-option]');
        var fv = first ? first.getAttribute('data-property-value') : null, sv = sel ? sel.getAttribute('data-property-value') : null;
        if (req && (!sel || sv === fv)) { out.missing.push(g); return; }
        if (sel) out.properties[g.getAttribute('data-property-name')] = sv;
      }
    });
    qsa('[data-addon-date-field]:not([hidden])').forEach(function (f) {
      var inp = f.querySelector('[data-addon-date-input]');
      if (inp && !inp.value) out.missing.push(f); else if (inp) out.properties[inp.getAttribute('data-property-name')] = inp.value;
    });
    return out;
  }
  /* Messages use an element the legacy script does not control (it hides its own error element
     whenever the add button text changes), so they stay visible until the next attempt. */
  function productError(text) {
    var el = qs('[data-vb-error]');
    if (!el) {
      var anchor = qs('[data-add-to-cart]');
      el = document.createElement('p'); el.className = 'product-addons__error'; el.setAttribute('data-vb-error', ''); el.setAttribute('role', 'alert');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(el, anchor); else document.body.insertBefore(el, document.body.firstChild);
    }
    el.textContent = text; el.hidden = false;
  }
  function clearNotice() {
    var n = qs('.valtiva-bundle-notice'); if (n) n.remove();
    var el = qs('[data-vb-error]'); if (el) { el.hidden = true; el.textContent = ''; }
  }
  function setBusy(ctx, on) {
    var b = ctx.button; if (!b) return;
    if (on) { ctx.original = b.textContent; b.disabled = true; b.textContent = b.getAttribute('data-adding-text') || 'Adding…'; }
    else { b.disabled = false; if (ctx.original != null) b.textContent = ctx.original; }
  }
  var MSG = {
    'cart-read': 'We could not check your cart just now, so nothing was added. Please try again.',
    'add-failed': 'We could not add this item to your cart. Your cart has not been changed.',
    'add-partial': 'Something went wrong while adding this item. The partial add was undone and your cart is unchanged.',
    'add-unknown': 'We could not confirm what was added. Please check your cart before checking out.'
  };

  /* ---------- add / replace ---------- */
  function addInstance(ctx, replacesId) {
    var id = newId(), q = ctx.quantity, addons = ctx.selections.addonVariantIds;
    var mp = copy(ctx.selections.properties); mp[K.ID] = id; mp[K.ROLE] = 'main'; mp[K.VER] = '2'; mp[K.N] = String(addons.length); if (replacesId) mp[K.REPL] = replacesId;
    var items = [{ id: ctx.mainVariantId, quantity: q, properties: mp }];
    addons.forEach(function (v) {
      var ap = {}; ap[K.ID] = id; ap[K.ROLE] = 'addon'; ap[K.VER] = '2'; if (replacesId) ap[K.REPL] = replacesId;
      items.push({ id: v, quantity: q, properties: ap });
    });
    return http('POST', '/cart/add.js', { items: items }).then(function (r) {
      if (r.ok && r.data && r.data.items && r.data.items.length === items.length) return { id: id, response: r.data };
      var code = r.ok ? 'add-partial' : 'add-failed', detail = r.data && r.data.description;
      return readCart().then(function (c) {
        var landed = c.items.filter(function (i) { return props(i)[K.ID] === id; }).map(function (i) { return i.key; });
        return removeKeys(landed).then(function () { throw fail(code, detail); }, function () { throw fail('add-unknown'); });
      }, function () { throw fail('add-unknown'); });
    });
  }
  function showConfirm(added) { if (window.valtivaShowConfirmPanel && added && added.response) window.valtivaShowConfirmPanel(added.response); }
  function showPending(ctx, oldId, added) {
    injectCss(); clearNotice();
    var n = document.createElement('div'); n.className = 'valtiva-bundle-notice'; n.setAttribute('role', 'alert');
    n.innerHTML = '<strong>Your new configuration was added, but the previous one could not be removed.</strong><br>Your cart now contains both. Please remove the previous version before checking out.<br><button type="button" data-vb-retry>Retry removing the previous version</button> <a href="/cart" style="font-size:12.5px">View cart</a>';
    var anchor = ctx.button || qs('[data-add-to-cart]'); if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(n, anchor); else document.body.insertBefore(n, document.body.firstChild);
    n.querySelector('[data-vb-retry]').addEventListener('click', function () {
      var b = this; b.disabled = true;
      removeBundle(oldId).then(function () { n.remove(); showConfirm(added); evaluate(); }, function () { b.disabled = false; productError('Still could not remove the previous version. Please remove it from your cart.'); });
    });
    evaluate();
  }
  function handleAdd(ctx) {
    if (busy) return;
    busy = true; setBusy(ctx, true); clearNotice();
    return readCart().then(function (cart) {
      var configs = findConfigs(cart, ctx.mainVariantId);
      if (!configs.length) return addInstance(ctx, null).then(function (added) { showConfirm(added); });
      return chooseConfiguration(configs, ctx).then(function (choice) {
        if (choice.action === 'cancel') return;
        if (choice.action === 'new') return addInstance(ctx, null).then(function (added) { showConfirm(added); });
        return addInstance(ctx, choice.id).then(function (added) {
          return removeBundle(choice.id).then(function () { showConfirm(added); }, function () { showPending(ctx, choice.id, added); });
        });
      });
    }).catch(function (err) {
      productError(MSG[err && err.code] || (err && err.detail) || MSG['add-failed']);
    }).then(function () { busy = false; setBusy(ctx, false); evaluate(); });
  }

  /* ---------- product submit interception: canary pages only, registered before the legacy script ---------- */
  function onSubmit(e) {
    if (!CFG.productEnabled) return;
    var form = qs('.product-single__form');
    if (!form || e.target !== form) return;
    e.preventDefault(); e.stopImmediatePropagation();       // the legacy handler never runs on canary pages
    if (busy) return;
    var sel = readSelections();
    var idInput = form.querySelector('[name="id"]');
    var mainVariantId = idInput ? idInput.value : '';
    if (sel.missing.length || !mainVariantId) {
      sel.missing.forEach(function (g) { if (g.classList) g.classList.add('product-addons__options--invalid'); });
      productError('Please complete all required selections above before adding to cart.');
      if (sel.missing[0] && sel.missing[0].scrollIntoView) sel.missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var qtyInput = null;
    if (form.elements && form.elements.namedItem) { qtyInput = form.elements.namedItem('quantity'); if (qtyInput && !qtyInput.tagName && qtyInput.length) qtyInput = qtyInput[0]; }
    if (!qtyInput) qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1; if (!(quantity >= 1)) quantity = 1;
    handleAdd({ selections: sel, labels: sel.labels, mainVariantId: mainVariantId, quantity: quantity, button: qs('[data-add-to-cart]') });
  }
  document.addEventListener('submit', onSubmit, true);

  /* ---------- cart page + drawer guard ---------- */
  var guard = { evaluating: false, again: false, timer: null, blocked: false };
  function analyse(cart) {
    var issues = [], groups = {}, items = cart.items || [];
    items.forEach(function (it) {
      if (!isV2(it)) return;
      var id = props(it)[K.ID]; var g = groups[id] || (groups[id] = { main: [], addon: [] });
      g[roleOf(it)].push(it);
    });
    Object.keys(groups).forEach(function (id) {
      var g = groups[id];
      if (!g.main.length) { issues.push({ type: 'orphan', id: id, keys: g.addon.map(function (i) { return i.key; }), text: 'Some linked option lines no longer belong to an item in your cart.' }); return; }
      var main = g.main[0], p = props(main), expected = parseInt(p[K.N] || '0', 10);
      if (g.main.length > 1) issues.push({ type: 'duplicate', id: id, text: 'One configuration appears more than once and cannot be matched.' });
      if (g.addon.length !== expected) issues.push({ type: 'incomplete', id: id, text: (main.product_title || 'An item') + ' is missing a required option line (for example its colour).' });
      else if (g.addon.some(function (a) { return a.quantity !== main.quantity; })) issues.push({ type: 'qty', id: id, mainQty: main.quantity, keys: g.addon.map(function (i) { return i.key; }), text: (main.product_title || 'An item') + ': the quantities of the item and its options no longer match.' });
      if (p[K.REPL] && groups[p[K.REPL]]) issues.push({ type: 'pending', id: id, oldId: p[K.REPL], text: 'A replacement was not completed: the previous version of an item is still in your cart.' });
    });
    var legacy = items.filter(function (i) { return !isV2(i) && CANARY.indexOf(i.handle) > -1; });
    if (legacy.length) issues.push({ type: 'legacy', keys: legacy.map(function (i) { return i.key; }), text: 'Some items were added before an update, so their colour selection cannot be verified automatically. Please remove them (use Remove) and add them again.' });
    return issues;
  }
  var ACTIONS = { orphan: ['remove-keys', 'Remove the leftover lines'], incomplete: ['remove-bundle', 'Remove this incomplete item'], duplicate: ['remove-bundle', 'Remove this configuration'], qty: ['restore-qty', 'Restore matching quantities'], pending: ['remove-bundle-old', 'Remove the previous version'] };
  function render(issues) {
    guard.blocked = issues.length > 0;
    qsa('#CartPageForm, #CartDrawerForm').forEach(function (form) {
      var b = qs('.valtiva-bundle-banner', form);
      if (!issues.length) { if (b) b.remove(); return; }
      injectCss();
      if (!b) { b = document.createElement('div'); b.className = 'valtiva-bundle-banner'; b.setAttribute('role', 'alert'); form.insertBefore(b, form.firstChild); }
      b.innerHTML = '<strong>Please resolve this before checking out.</strong> (This check runs in your browser; it cannot see changes made elsewhere.)<ul>' + issues.map(function (is) {
        var a = ACTIONS[is.type]; var arg = is.type === 'orphan' ? is.keys.join(',') : (is.type === 'pending' ? is.oldId : (is.id || ''));
        return '<li>' + esc(is.text) + (a ? ' <button type="button" data-vb-action="' + a[0] + '" data-vb-arg="' + esc(arg) + '" data-vb-type="' + is.type + '" data-vb-qty="' + esc(is.mainQty || '') + '" data-vb-keys="' + esc((is.keys || []).join(',')) + '">' + a[1] + '</button>' : '') + '</li>';
      }).join('') + '</ul>';
    });
    qsa('[name="checkout"], .cart__checkout').forEach(function (btn) {
      if (guard.blocked) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.classList.add('valtiva-bundle-blocked'); btn.title = 'Please resolve the notice above first'; }
      else if (btn.classList.contains('valtiva-bundle-blocked')) { btn.disabled = false; btn.removeAttribute('aria-disabled'); btn.classList.remove('valtiva-bundle-blocked'); btn.removeAttribute('title'); }
    });
  }
  function evaluate() {
    if (guard.evaluating) { guard.again = true; return Promise.resolve(); }
    if (!qs('.cart__item') && !qs('.valtiva-bundle-banner')) return Promise.resolve();
    guard.evaluating = true;
    return readCart().then(function (cart) { render(analyse(cart)); }, function () {}).then(function () {
      guard.evaluating = false; if (guard.again) { guard.again = false; schedule(); }
    });
  }
  function schedule() { clearTimeout(guard.timer); guard.timer = setTimeout(evaluate, 200); }
  api.reload = function () { window.location.reload(); };

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var act = t.closest('[data-vb-action]');
    if (act) {
      e.preventDefault(); var type = act.getAttribute('data-vb-action'), arg = act.getAttribute('data-vb-arg'); act.disabled = true;
      var p;
      if (type === 'remove-keys') p = removeKeys(arg.split(',').filter(Boolean));
      else if (type === 'remove-bundle' || type === 'remove-bundle-old') p = removeBundle(arg);
      else if (type === 'restore-qty') p = readCart().then(function (c) { var u = {}, q = parseInt(act.getAttribute('data-vb-qty'), 10); c.items.forEach(function (i) { if (props(i)[K.ID] === arg && roleOf(i) === 'addon') u[i.key] = q; }); return http('POST', '/cart/update.js', { updates: u }).then(function (r) { if (!r.ok) throw fail('update-failed'); }); });
      p.then(function () { api.reload(); }, function () { act.disabled = false; });
      return;
    }
    var a = t.closest('a'); if (!a) return;
    var line = a.closest('.cart__item[data-bundle-role="main"]');
    if (line && (a.getAttribute('href') || '').indexOf('/cart/change') > -1) {      // remove a main line = remove its whole bundle
      e.preventDefault(); e.stopImmediatePropagation();
      removeBundle(line.getAttribute('data-bundle-id')).then(function () { api.reload(); }, function () { render([{ type: 'remove-failed', text: 'We could not remove this item. Please try again.' }]); });
      return;
    }
    if ((a.getAttribute('href') || '').indexOf('/checkout') > -1 && guard.blocked) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {          // block the cart form's checkout while the guard has a notice
    if (!guard.blocked || !e.target || !e.target.id || ['CartPageForm', 'CartDrawerForm'].indexOf(e.target.id) === -1) return;
    e.preventDefault(); e.stopImmediatePropagation();
  }, true);

  function start() {
    injectCss(); schedule();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        var relevant = muts.some(function (m) { var t = m.target; return !(t.closest && (t.closest('.valtiva-bundle-banner') || t.closest('#ValtivaBundleModal') || t.closest('.valtiva-bundle-notice'))); });
        if (relevant && (qs('.cart__item') || qs('.valtiva-bundle-banner'))) schedule();
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  api.version = '2.0-canary'; api.handleAdd = handleAdd; api.evaluate = evaluate; api.removeBundle = removeBundle; api.analyse = analyse;
  window.valtivaBundles = api;
})();
